import { useInfiniteQuery } from '@tanstack/react-query'
import { rocketGameService } from '../../../services/rockets-games'
import type { GetList } from '../../../services/rockets-games/types'

export const ROCKETS_GAMES_QUERY_KEY = 'getRocketsGames'

export const useGetRocketsGames = (params?: GetList.Input) => {
  const { data, isFetchingNextPage, isLoading, refetch, fetchNextPage } =
    useInfiniteQuery({
      queryKey: [ROCKETS_GAMES_QUERY_KEY, params],
      initialPageParam: 0,
      queryFn: ({ pageParam: skip }) => {
        return rocketGameService.getList({ take: 20, skip, ...params })
      },
      getNextPageParam: (lastPage, _allPages, lastPageParam) => {
        if (lastPage?.error) return null

        if (lastPage && !lastPage?.data?.length) return null

        return lastPageParam + 1
      },
    })

  return {
    rocketsGames: data?.pages?.flatMap((page) => page?.data),
    isFetchingNextPage,
    isLoading,
    nextPage: fetchNextPage,
    refetch,
  }
}
